import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { InventoryType } from '../../models/inventory/inventory-type';

@Injectable({
  providedIn: 'root',
})
export class InventoryTypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-type';

  public getAll(): Observable<ApiResponse<InventoryType[]>> {
    return this.httpClient.get<ApiResponse<InventoryType[]>>(`${this.baseUrl}/all`);
  }

  public createInventoryType(inventoryType: InventoryType): Observable<ApiResponse<InventoryType>> {
    return this.httpClient.post<ApiResponse<InventoryType>>(this.baseUrl, inventoryType);
  }

  public updateInventoryType(id: string, inventoryType: InventoryType): Observable<ApiResponse<InventoryType>> {
    return this.httpClient.put<ApiResponse<InventoryType>>(`${this.baseUrl}/${id}`, inventoryType);
  }

  public deleteInventoryTypeById(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
